import { createSlice } from '@reduxjs/toolkit';

// v2 of jiraReducers file
const initialState = {
  allProjectsAndSubtickets: [],
  myProjectsAndSubtickets: [],
  projectByKeycustomerProjects: [],
  projectByKey: {},
  projectSubTicketByKey: {},
  jiraAuthenticationURL: '',
  jiraAuthorization: '',
  jiraToken: '',
  selectedSiteID: '',
  jiraApiKey: {},
  alltickets: [],
  jiraWorklog: {},
  userTicketData: {},
  customerTickets: [],
  userTicket: [],
  mergedTicket: {},
  unmergedTicket: {},
  projectTickets: [],
  userTimeTrackingByTicket: [],
  ticket: {},
  newTicket: {},
  userTickets: [],
  newTicketLoading: false,
  updatedTicket: {},
  deletedTicket: {},
  allJiraTimeTracking: [],
  toggleModal: false,
  supportTicketsLoading: false,
  projectTicketsLoading: false,
  fieldPriorityLoading: false,
  fieldProjectLoading: false,
  fieldRemainingTimeEstimateLoading: false,
  fieldTimeOverLoading: false,
  fieldTimespentLoading: false,
  jiraTicketSearch: [],
  stnActiveEng: [],
  assignees: [],
  selectedCustomerAssignees: [],
  serviceCodes: [],
  isLoading: false,
  error: [],
  getAllAdminNotes: [],
  allJiraTickets: [],
  adminNotes: [],
  customerProjects: [],
  ticketsProjects: [],
  refreshToken: '',
  filterTicketsText: 'mine',
  filterProjectTicketsText: 'mine',
  prevTicketPageRoute: '/tickets/',
  allProjectsAndSubticketsLastUpdated: null,
  analyseAlertDataWithAlertID: null,
  toggleTicketFilters: false,
  ticketFilters: {
    ticketNumber: null,
    customerID: null,
    siteID: null,
    assignee: null,
    status: null,
    priority: null,
    project: null,
    dateStart: null,
    dateEnd: null,
  },
  toggleProjectFilters: false,
  analyseAlertData: [],
  projectFilters: {
    // ticketNumber: null,
    customerID: null,
    siteID: null,
    assignee: null,
    // status: null,
    // priority: null,
    // dateStart: null,
    // dateEnd: null,
  },
  jiraApiKeyStatus: null,
  ticketCommentsData: [],
  isLoadingTicketComments: false,
  isLoadingAdminNotes: false,
  isAssigneesLoading: false,
  jiraWorklogData: [],
  isLoadingJiraWorklog: false,
  jiraAttachmentContent: [],
  isLoadingJiraAttachmentContent: false,
  fieldServiceCodeLoading: false,
  startDescriptionLoading: false,
  startLabelsLoading: false,
  startPriorityLoading: false,
  startReporterLoading: false,
  startAssigneeLoading: false,
  startServiceCodeLoading: false,
  startStartDateLoading: false,
  startDueDateLoading: false,
  startTimeEstimateLoading: false,
  startStatusSummaryLoading: false,
  startCustomerIDLoading: false,
  startSiteIDLoading: false,
  startRemainingTimeEstimateLoading: false,
  startTimeOverLoading: false,
  startTimespentLoading: false,
  fieldData: {
    description: null,
    labels: [],
    priority: null,
    reporter: null,
    assigneeEmail: null,
    servicecode: null,
    team: null,
    project: null,
    duedate: null,
    timeestimate: null,
    startDate: null,
    statusSummary: null,
    customerID: null,
    siteID: [],
    remainingtimeestimate: null,
    timeover: null,
    timespent: null,
  },
  isTicketTransitionLoading: false,
  allJiraProjects: [],
  isUserTicketDataLoading: false,
  specialInstructionsData: null,
  isSpecialInstructionsLoading: false,
  isCustomerProjectsLoading: false,
  isJiraTicketTeamLoading: false,
  jiraTicketTeamData: null,
};

const jiraSlice = createSlice({
  name: 'jira',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.newTicketLoading = true;
      state.error = [];
    },
    startCustomerProjectsLoading: (state, action) => {
      state.isCustomerProjectsLoading = true;
    },
    stopCustomerProjectsLoading: (state, action) => {
      state.isCustomerProjectsLoading = false;
    },
    setIsLoadingJiraWorklog: (state, action) => {
      state.isLoadingJiraWorklog = action.payload;
    },
    startSpecialInstructionsLoading: (state, action) => {
      state.isSpecialInstructionsLoading = true;
    },
    stopSpecialInstructionsLoading: (state, action) => {
      state.isSpecialInstructionsLoading = false;
    },
    startTicketComments: (state, action) => {
      state.isLoadingTicketComments = true;
    },
    stopTicketComments: (state, action) => {
      state.isLoadingTicketComments = false;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.newTicketLoading = false;
    },
    setToggleTicketFilters: (state, action) => {
      state.toggleTicketFilters = !state.toggleTicketFilters;
    },
    setToggleTicketFiltersTrue: (state, action) => {
      state.toggleTicketFilters = true;
    },
    setTicketFilters: (state, action) => {
      state.ticketFilters[action.payload.key] = action.payload.value;
    },
    resetToggleTicketFilters: (state, action) => {
      state.toggleTicketFilters = false;
    },
    resetTicketFilters: (state, action) => {
      state.ticketFilters = {
        ticketNumber: null,
        customerID: null,
        siteID: null,
        assignee: null,
        status: null,
        priority: null,
        project: null,
        dateStart: null,
        dateEnd: null,
      };
    },
    setToggleProjectFilters: (state, action) => {
      state.toggleProjectFilters = !state.toggleProjectFilters;
    },
    setProjectFilters: (state, action) => {
      state.projectFilters[action.payload.key] = action.payload.value;
    },
    resetToggleProjectFilters: (state, action) => {
      state.toggleProjectFilters = false;
    },
    resetProjectFilters: (state, action) => {
      state.projectFilters = {
        // ticketNumber: null,
        customerID: null,
        siteID: null,
        assignee: null,
        // status: null,
        // priority: null,
        // dateStart: null,
        // dateEnd: null,
      };
    },
    setBulkTicketUpdate: (state, action) => {
      state.bulkTicketUpdate = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUserTicketData: (state, action) => {
      state.userTicketData = action.payload;
      // state.isLoading = false;
      state.isUserTicketDataLoading = false;
      state.error = [];
    },
    setAnalyseAlertDataWithAlertID: (state, action) => {
      state.analyseAlertDataWithAlertID = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllProjects: (state, action) => {
      state.allProjects = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllProjectsAndSubtickets: (state, action) => {
      state.allProjectsAndSubtickets = action.payload;
      state.allProjectsAndSubticketsLastUpdated = Date.now();
      state.isLoading = false;
      state.error = [];
    },
    clearAllProjectsAndSubtickets: (state) => {
      state.allProjectsAndSubtickets = [];
      state.allProjectsAndSubticketsLastUpdated = null;
    },
    setMyProjectsAndSubtickets: (state, action) => {
      state.myProjectsAndSubtickets = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setGetAllAdminNotes: (state, action) => {
      state.getAllAdminNotes = action.payload;
      state.isLoadingAdminNotes = false;
      state.isLoading = false;
      state.error = [];
    },
    setAdminNotes: (state, action) => {
      state.adminNotes = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraTickets: (state, action) => {
      state.alltickets = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllJiraTickets: (state, action) => {
      state.allJiraTickets = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAssignees: (state, action) => {
      state.assignees = action.payload;
      state.isAssigneesLoading = false;
      state.isLoading = false;
      state.error = [];
    },
    setSelectedCustomerAssignees: (state, action) => {
      state.selectedCustomerAssignees = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setServiceCodes: (state, action) => {
      state.serviceCodes = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUserTimeTrackingByTicket: (state, action) => {
      state.userTimeTrackingByTicket = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllJiraTimeTracking: (state, action) => {
      state.allJiraTimeTracking = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUserTickets: (state, action) => {
      state.userTickets = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraTicketSearch: (state, action) => {
      state.jiraTicketSearch = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraToken: (state, action) => {
      state.jiraToken = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraAuthorization: (state, action) => {
      state.jiraAuthorization = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraAuthenticationURL: (state, action) => {
      state.jiraAuthenticationURL = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraTicketsIssues: (state, action) => {
      state.alltickets.issues = [...state.alltickets.issues, ...action.payload];
      state.isLoading = false;
      state.error = [];
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerProjects: (state, action) => {
      state.customerProjects = action.payload;
      state.isLoading = false;
      state.isCustomerProjectsLoading = false;
      state.error = [];
    },
    setTicketsProjects: (state, action) => {
      state.ticketsProjects = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setMergedTicket: (state, action) => {
      state.mergedTicket = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUnmergedTicket: (state, action) => {
      state.unmergedTicket = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setProjectByKey: (state, action) => {
      state.projectByKey = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setProjectSubTicketByKey: (state, action) => {
      state.projectSubTicketByKey = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setJiraTicketByKey: (state, action) => {
      state.ticket = action.payload || null;
      state.isLoading = false;
      state.isTicketTransitionLoading = false;
      state.error = [];
    },
    setJiraWorklog: (state, action) => {
      state.jiraWorklog = action.payload;
      state.isLoading = false;
      state.isLoadingJiraWorklog = false;
      state.error = [];
    },
    setCustomerTickets: (state, action) => {
      state.customerTickets = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerTicketsIssues: (state, action) => {
      state.customerTickets.issues = [...state.customerTickets.issues, ...action.payload];
      state.isLoading = false;
      state.error = [];
    },
    setProjectTickets: (state, action) => {
      state.projectTickets = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setProjectTicketsIssues: (state, action) => {
      state.projectTickets.issues = [...state.projectTickets.issues, ...action.payload];
      state.isLoading = false;
      state.error = [];
    },
    setNewTicketAndAllTickets: (state, action) => {
      state.newTicket = action.newTicket;
      state.alltickets = action.tickets;
      state.isLoading = false;
      state.error = [];
    },
    setDeletedTicket: (state, action) => {
      state.deletedTicket = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFilterTicket: (state, action) => {
      state.filterTicketsText = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    stnActiveStnEng: (state, action) => {
      state.stnActiveEng = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFilterProjectTicket: (state, action) => {
      state.filterProjectTicketsText = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSelectedSiteID: (state, action) => {
      state.selectedSiteID = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setPrevTicketPageRoute: (state, action) => {
      state.prevTicketPageRoute = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAnalyseAlertData: (state, action) => {
      state.analyseAlertData = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleModal: (state, action) => {
      state.toggleModal = !state.toggleModal;
    },
    setSupportTicketsLoading: (state, action) => {
      state.supportTicketsLoading = action.payload;
    },
    setProjectTicketsLoading: (state, action) => {
      state.projectTicketsLoading = action.payload;
    },
    setToggleBulkUpdateModal: (state, action) => {
      state.toggleBulkUpdateModal = !state.toggleBulkUpdateModal;
    },
    setJiraApiKey: (state, action) => {
      state.jiraApiKey = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setResetJiraTicket: () => {
      return initialState;
    },
    setJiraApiKeyStatus: (state, action) => {
      state.jiraApiKeyStatus = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setTicketCommentsData: (state, action) => {
      state.ticketCommentsData = action.payload;
      state.isLoadingTicketComments = false;
      state.error = [];
    },
    startAdminNotes: (state, action) => {
      state.isLoadingAdminNotes = true;
    },
    stopAdminNotes: (state, action) => {
      state.isLoadingAdminNotes = false;
    },
    startAssigneesLoading: (state, action) => {
      state.isAssigneesLoading = true;
    },
    stopAssigneesLoading: (state, action) => {
      state.isAssigneesLoading = false;
    },
    setJiraWorklogData: (state, action) => {
      state.jiraWorklogData = action.payload;
      state.isLoadingJiraWorklog = false;
      state.error = [];
    },
    startJiraWorklog: (state, action) => {
      state.isLoadingJiraWorklog = true;
    },
    stopJiraWorklog: (state, action) => {
      state.isLoadingJiraWorklog = false;
    },
    setJiraAttachmentContent: (state, action) => {
      state.jiraAttachmentContent = action.payload;
      state.isLoadingJiraAttachmentContent = false;
      state.error = [];
    },
    startJiraAttachmentContent: (state, action) => {
      state.isLoadingJiraAttachmentContent = true;
    },
    stopJiraAttachmentContent: (state, action) => {
      state.isLoadingJiraAttachmentContent = false;
    },
    startPriorityFieldLoading: (state, action) => {
      state.fieldPriorityLoading = true;
    },

    stopPriorityFieldLoading: (state, action) => {
      state.fieldPriorityLoading = false;
    },

    setFieldData: (state, action) => {
      const { field, value } = action.payload;
      if (!state.fieldData) {
        state.fieldData = {};
      }
      switch (field) {
        case 'labels':
          state.fieldData[field] = Array.isArray(value) ? value : [];
          break;

        case 'siteID':
          state.fieldData[field] = Array.isArray(value) ? value : [];
          break;

        case 'reporter':
          state.fieldData[field] = value;
          break;

        case 'priority':
          state.fieldData.priority = value;
          break;

        case 'project':
          state.fieldData.project = value;
          break;
        case 'servicecode':
          state.fieldData.servicecode = value;
          break;
        case 'description':
          state.fieldData.description = value;
          break;
        case 'duedate':
          console.log(action.payload, 'setFieldDatazdx');
          state.fieldData.duedate = value;
          break;
        case 'timeEstimate':
          state.fieldData.timeestimate = value;
          break;
        case 'startDate':
          state.fieldData.startDate = value;
          break;
        case 'statusSummary':
          state.fieldData.statusSummary = value;
          break;
        case 'customerID':
          state.fieldData.customerID = value;
          break;
        case 'assigneeEmail':
          state.fieldData.assigneeEmail = value;
          break;
        case 'assignee':
          state.fieldData.assignee = value;
          break;
        case 'remainingtimeestimate':
          state.fieldData.remainingtimeestimate = value;
          break;
        case 'timeover':
          state.fieldData.timeover = value;
          break;
        case 'timespent':
          state.fieldData.timespent = value;
          break;
        case 'team':
          state.fieldData.team = value;
          break;

        default:
          state.fieldData[field] = value !== undefined ? value : null;
      }
    },
    startRemainingTimeEstimateLoading: (state, action) => {
      state.startRemainingTimeEstimateLoading = true;
    },
    stopRemainingTimeEstimateLoading: (state, action) => {
      state.startRemainingTimeEstimateLoading = false;
    },
    startTimeOverLoading: (state, action) => {
      state.startTimeOverLoading = true;
    },
    stopTimeOverLoading: (state, action) => {
      state.startTimeOverLoading = false;
    },
    startTimespentLoading: (state, action) => {
      state.startTimespentLoading = true;
    },
    stopTimespentLoading: (state, action) => {
      state.startTimespentLoading = false;
    },
    startDescriptionLoading: (state, action) => {
      state.startDescriptionLoading = true;
    },
    stopDescriptionLoading: (state, action) => {
      state.startDescriptionLoading = false;
    },
    startLabelsLoading: (state, action) => {
      state.startLabelsLoading = true;
    },
    stopLabelsLoading: (state, action) => {
      state.startLabelsLoading = false;
    },
    startPriorityLoading: (state, action) => {
      state.startPriorityLoading = true;
    },
    stopPriorityLoading: (state, action) => {
      state.startPriorityLoading = false;
    },
    startReporterFieldLoading: (state, action) => {
      state.startReporterLoading = true;
    },
    stopReporterFieldLoading: (state, action) => {
      state.startReporterLoading = false;
    },
    startAssigneeFieldLoading: (state, action) => {
      state.startAssigneeLoading = true;
    },
    stopAssigneeFieldLoading: (state, action) => {
      state.startAssigneeLoading = false;
    },
    startServiceCodeFieldLoading: (state, action) => {
      state.fieldServiceCodeLoading = true;
    },
    stopServiceCodeFieldLoading: (state, action) => {
      state.fieldServiceCodeLoading = false;
    },
    startAssignTeamFieldLoading: (state, action) => {
      state.fieldAssignTeamLoading = true;
    },
    stopAssignTeamFieldLoading: (state, action) => {
      state.fieldAssignTeamLoading = false;
    },
    startStartDateFieldLoading: (state, action) => {
      state.startStartDateLoading = true;
    },
    stopStartDateFieldLoading: (state, action) => {
      state.startStartDateLoading = false;
    },
    startDueDateFieldLoading: (state, action) => {
      state.startDueDateLoading = true;
    },
    stopDueDateFieldLoading: (state, action) => {
      state.startDueDateLoading = false;
    },
    startTimeEstimateFieldLoading: (state, action) => {
      state.startTimeEstimateLoading = true;
    },
    stopTimeEstimateFieldLoading: (state, action) => {
      state.startTimeEstimateLoading = false;
    },
    startStatusSummaryFieldLoading: (state, action) => {
      state.startStatusSummaryLoading = true;
    },
    stopStatusSummaryFieldLoading: (state, action) => {
      state.startStatusSummaryLoading = false;
    },
    startCustomerIDFieldLoading: (state, action) => {
      state.startCustomerIDLoading = true;
    },
    stopCustomerIDFieldLoading: (state, action) => {
      state.startCustomerIDLoading = false;
    },
    startSiteIDFieldLoading: (state, action) => {
      state.startSiteIDLoading = true;
    },
    stopSiteIDFieldLoading: (state, action) => {
      state.startSiteIDLoading = false;
    },
    startProjectFieldLoading: (state, action) => {
      state.fieldProjectLoading = true;
    },

    stopProjectFieldLoading: (state, action) => {
      state.fieldProjectLoading = false;
    },
    startDescriptionFieldLoading: (state, action) => {
      state.startDescriptionLoading = true;
    },
    stopDescriptionFieldLoading: (state, action) => {
      state.startDescriptionLoading = false;
    },
    startLabelsFieldLoading: (state, action) => {
      state.startLabelsLoading = true;
    },
    stopLabelsFieldLoading: (state, action) => {
      state.startLabelsLoading = false;
    },

    startTicketTransition: (state, action) => {
      state.isTicketTransitionLoading = true;
    },
    stopTicketTransition: (state, action) => {
      state.isTicketTransitionLoading = false;
    },
    setAllJiraProjects: (state, action) => {
      state.allJiraProjects = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    startUserTicketData: (state, action) => {
      state.isUserTicketDataLoading = true;
    },
    stopUserTicketData: (state, action) => {
      state.isUserTicketDataLoading = false;
    },
    setSpecialInstructionsData: (state, action) => {
      state.specialInstructionsData = action.payload;
      state.isSpecialInstructionsLoading = false;
      state.error = [];
    },
    startTeamFieldLoading: (state, action) => {
      state.isJiraTicketTeamLoading = true;
    },
    stopTeamFieldLoading: (state, action) => {
      state.isJiraTicketTeamLoading = false;
    },
    setJiraTicketTeamData: (state, action) => {
      state.jiraTicketTeamData = action.payload;
      state.isJiraTicketTeamLoading = false;
      state.error = [];
    },
    resetTicketClickedStates: (state) => {
      state.ticket = null;
      state.analyseAlertDataWithAlertID = null;
      state.jiraAttachmentContent = [];
      state.ticketCommentsData = [];
      state.fieldData = {
        description: null,
        labels: [],
        priority: null,
        reporter: null,
        assigneeEmail: null,
        servicecode: null,
        team: null,
        project: null,
        duedate: null,
        timeestimate: null,
        startDate: null,
        statusSummary: null,
        customerID: null,
        siteID: [],
        remainingtimeestimate: null,
        timeover: null,
        timespent: null,
      };
    },
  },
});

export const {
  start,
  setIsLoadingJiraWorklog,
  setReducerError,
  setToggleTicketFilters,
  setToggleTicketFiltersTrue,
  setAnalyseAlertDataWithAlertID,
  setAnalyseAlertData,
  setTicketFilters,
  resetToggleTicketFilters,
  resetTicketFilters,
  setToggleProjectFilters,
  setProjectFilters,
  resetToggleProjectFilters,
  resetProjectFilters,
  setBulkTicketUpdate,
  setAllProjects,
  setAllProjectsAndSubtickets,
  setMyProjectsAndSubtickets,
  setGetAllAdminNotes,
  setAdminNotes,
  setJiraTickets,
  setAssignees,
  setSelectedCustomerAssignees,
  setServiceCodes,
  setUserTimeTrackingByTicket,
  setAllJiraTimeTracking,
  setUserTickets,
  setJiraTicketSearch,
  setJiraToken,
  setJiraAuthorization,
  setJiraAuthenticationURL,
  setJiraTicketsIssues,
  setRefreshToken,
  setCustomerProjects,
  setUserTicketData,
  setMergedTicket,
  setUnmergedTicket,
  setProjectByKey,
  setProjectSubTicketByKey,
  setJiraTicketByKey,
  setJiraWorklog,
  setCustomerTickets,
  setCustomerTicketsIssues,
  setProjectTickets,
  setProjectTicketsIssues,
  setNewTicketAndAllTickets,
  setDeletedTicket,
  setToggleModal,
  setSupportTicketsLoading,
  setProjectTicketsLoading,
  setToggleBulkUpdateModal,
  setAllJiraTickets,
  setFilterTicket,
  setFilterProjectTicket,
  setPrevTicketPageRoute,
  setSelectedSiteID,
  setResetJiraTicket,
  stnActiveStnEng,
  setTicketsProjects,
  setJiraApiKey,
  setJiraApiKeyStatus,
  setTicketCommentsData,
  startTicketComments,
  stopTicketComments,
  startAdminNotes,
  stopAdminNotes,
  startAssigneesLoading,
  stopAssigneesLoading,
  setJiraWorklogData,
  startJiraWorklog,
  stopJiraWorklog,
  setJiraAttachmentContent,
  startJiraAttachmentContent,
  stopJiraAttachmentContent,
  startFieldLoading,
  stopFieldLoading,
  setFieldData,
  startPriorityFieldLoading,
  stopPriorityFieldLoading,
  startProjectFieldLoading,
  stopProjectFieldLoading,
  startServiceCodeFieldLoading,
  stopServiceCodeFieldLoading,
  startStartDateFieldLoading,
  stopStartDateFieldLoading,
  startDueDateFieldLoading,
  stopDueDateFieldLoading,
  startTimeEstimateFieldLoading,
  stopTimeEstimateFieldLoading,
  startStatusSummaryFieldLoading,
  stopStatusSummaryFieldLoading,
  startCustomerIDFieldLoading,
  stopCustomerIDFieldLoading,
  startSiteIDFieldLoading,
  stopSiteIDFieldLoading,
  startDescriptionFieldLoading,
  stopDescriptionFieldLoading,
  startLabelsFieldLoading,
  stopLabelsFieldLoading,
  startReporterFieldLoading,
  stopReporterFieldLoading,
  startAssigneeFieldLoading,
  stopAssigneeFieldLoading,
  startTicketTransition,
  stopTicketTransition,
  startRemainingTimeEstimateLoading,
  stopRemainingTimeEstimateLoading,
  startTimeOverLoading,
  stopTimeOverLoading,
  startTimespentLoading,
  stopTimespentLoading,
  setAllJiraProjects,
  resetTicketClickedStates,
  startUserTicketData,
  stopUserTicketData,
  startSpecialInstructionsLoading,
  stopSpecialInstructionsLoading,
  setSpecialInstructionsData,
  startCustomerProjectsLoading,
  stopCustomerProjectsLoading,
  startAssignTeamFieldLoading,
  stopAssignTeamFieldLoading,
  startTeamFieldLoading,
  stopTeamFieldLoading,
  setJiraTicketTeamData,
} = jiraSlice.actions;

export default jiraSlice.reducer;

// ------------check and clear stale projects and subtickets-----------
export const checkAndClearStaleProjectsAndSubtickets = (staleTime) => (dispatch, getState) => {
  const state = getState();
  const isStale = isAllProjectsAndSubticketsStale(state, staleTime);
  if (isStale) {
    dispatch(jiraSlice.actions.clearAllProjectsAndSubtickets());
  }
};

export const isAllProjectsAndSubticketsStale = (state, staleTime) => {
  const lastUpdated = state.jira?.allProjectsAndSubticketsLastUpdated;
  return !lastUpdated || Date.now() - lastUpdated > staleTime;
};
